import { twMerge } from 'tailwind-merge';
import { TextWithDropShadow } from '../TextWithDropShadow';
import Heading from '../common/Heading';

export interface StrapiIntertekBlockData {
  title: string;
  topBlock: {
    text: string;
    display: boolean;
    shadow: boolean;
  };
  midBlock: {
    text: string;
    display: boolean;
    shadow: boolean;
  };
  listLeft: {
    text: string;
    shadow: boolean;
    hidden: boolean;
    size: {
      size: string;
    };
    color: {
      color: string;
    };
  };
  listRight: {
    text: string;
    shadow: boolean;
    hidden: boolean;
    size: {
      size: string;
    };
    color: {
      color: string;
    };
  };
  padding: {
    top: string;
    right: string;
    bottom: string;
    left: string;
  };
}

export default function IntertekBlock({
  data,
}: {
  data: StrapiIntertekBlockData;
}) {
  const paddingClass =
    data.padding &&
    `p-0 pt-${data.padding.top} md:pr-${data.padding.right} pb-${data.padding.bottom} md:pl-${data.padding.left} `;
  return (
    <div
      className={`${paddingClass} mx-auto flex w-full max-w-6xl flex-col gap-8 lg:gap-12`}
    >
      <div className='flex flex-col gap-8 md:flex-row'>
        <div className='flex h-max w-full flex-row items-center gap-6 md:w-1/2 lg:w-2/5'>
          <img
            src='https://res.cloudinary.com/dbkbadq4w/image/upload/v1747937483/intertek-badge_pofelp.png'
            alt='Intertek Certified Badge'
          />
          <h3 className='false text-3xl font-bold md:text-4xl'>
            Intertek-Tested &amp;
            <br /> <span className='text-primary'>Certified</span>
          </h3>
        </div>
        <div className='flex h-max w-full flex-col gap-6 text-base font-semibold text-gray-900 md:w-1/2 lg:w-3/5'>
          <p>
            When it comes to easy installation and peace of mind, MRCOOL®
            stands alone as the ONLY company with patented pre-charged line set
            valves that have been tested and certified by Intertek.
          </p>
          {/* <p>
            With the Intertek stamp of approval, homeowners and contractors
            alike can be sure that their DIY® installation will be faster,
            safer, and fully compliant with industry standards.
          </p> */}
          <p>
            With the Intertek stamp of approval, homeowners and contractors
            alike can be sure that their pre-charged installation will be
            faster, safer, and fully compliant with industry standards.
          </p>
        </div>
      </div>
      <div className='flex w-full'>
        <div className='flex w-full flex-col gap-0 text-lg md:flex-row md:gap-4'>
          <div className='w-full md:w-1/2 lg:w-2/5'>
            <div className='mb-6 max-w-sm rounded-2xl bg-gradient-to-t from-sky-700 to-sky-950 p-4'>
              <div className='font-medium'>
                {/* <div className='w-full text-neutral-300'>
                  DIY Valve Control Intertek Number
                </div> */}
                {/* <div className='w-full text-white'>5029890</div> */}
                <div className='w-full text-neutral-300'>
                  Pre-Charged Valve Control Intertek Number
                </div>
                <div className='w-full text-white'>5029931</div>
              </div>
              <hr className='my-4 border-sky-700'></hr>
              <div className='font-medium'>
                <div className='w-full text-neutral-300'>Certified Under</div>
                <div className='w-full text-white'>
                  UL STD 207 | CSA STD C22.2 # 140.3
                </div>
              </div>
            </div>
          </div>
          <div className='flex w-full flex-row flex-wrap md:w-1/2 lg:w-3/5'>
            <div className='mb-4 w-full gap-1 md:w-1/2'>
              <img
                src='https://res.cloudinary.com/dbkbadq4w/image/upload/v1748013643/intertek-icons_rated_vpislh.png'
                alt='Star'
              />
              <h5 className='font-semibold'>Rated to Handle 921 PSI</h5>
              <p className='text-neutral-600'>
                Built to last and tested for strength and leakage
              </p>
            </div>
            <div className='mb-4 w-full gap-1 md:w-1/2'>
              <img
                src='https://res.cloudinary.com/dbkbadq4w/image/upload/v1748013643/intertek-icons_patient-protected_mjq4xq.png'
                alt='Protected'
              />
              <h5 className='font-semibold'>Patent-Protected Design</h5>
              <p className='text-neutral-600'>
                No other line set has this level of certification or innovation
              </p>
            </div>
            <div className='mb-4 w-full gap-1 md:w-1/2'>
              <img
                src='https://res.cloudinary.com/dbkbadq4w/image/upload/v1748013643/intertek-icons_usage_hnftbe.png'
                alt='Usage'
              />
              <h5 className='font-semibold'>Versatile Usage</h5>
              <p className='text-neutral-600'>Works with R454B refrigerants</p>
            </div>
            <div className='mb-4 w-full gap-1 md:w-1/2'>
              <img
                src='https://res.cloudinary.com/dbkbadq4w/image/upload/v1748013642/intertek-icons_certified_vc6rct.png'
                alt='Certified'
              />
              <h5 className='font-semibold'>Intertek Certified</h5>
              <p className='text-neutral-600'>
                Backed by Intertek lab testing at Intertek Plano (TX) with full
                safety and pressure validation
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
